import InboxRulesOption from 'owa-inbox-rules-option/lib/InboxRulesOption';
var rulesSubCategory = {
    key: 'rules',
    titleStringKey: 'optionSubcategory_rules',
    options: [InboxRulesOption],
};
export default rulesSubCategory;
//# sourceMappingURL=rulesSubCategory.js.map